export default {
  sectionTitle: {
    id: 'searchbar_recently_viewed_title',
    defaultMessage: 'Recent',
  },
}
